import { useState } from 'react';
import { HttpMethod, HttpWrapper } from '../../../../../helpers/httpWrapper';
import {
	ICommunityAnalyticsInitRequest,
	ICommunityAnalyticsInitResponse,
	VCommunityAnalyticsInit,
} from '../../../../../networked-shared-interfaces/interfaces-phase2/platform-admin/sub-routes/community';
import { URLWrapper } from '../../../../../networked-shared-interfaces/url-wrapper';
import { toastService } from '../../../../../services/toast.service';

interface ICommunityAnalyticsState {
	loading: boolean;
	error: string | null;
	result: ICommunityAnalyticsInitResponse | null;
}

export const useCommunityAnalytics = () => {
	const [state, setState] = useState<ICommunityAnalyticsState>({
		loading: false,
		error: null,
		result: null,
	});

	const saveAnalyticsKey = async (
		communityId: string,
		posthogApiKey: string
	): Promise<ICommunityAnalyticsInitResponse | null> => {
		setState({ loading: true, error: null, result: null });

		try {
			const body: ICommunityAnalyticsInitRequest = {
				communityId,
				posthogApiKey: posthogApiKey.trim(),
			};

			const res = await HttpWrapper.callUrl<ICommunityAnalyticsInitRequest, ICommunityAnalyticsInitResponse>(
				URLWrapper.urls.platformAdmin.communityAnalytics,
				HttpMethod.POST,
				body,
				VCommunityAnalyticsInit
			);

			setState({ loading: false, error: null, result: res });
			toastService.success('PostHog Analytics saved successfully!');
			return res;
		} catch (err: any) {
			const message = err?.message || 'Failed to save PostHog Analytics.';
			setState({ loading: false, error: message, result: null });
			toastService.error(message);
			return null;
		}
	};

	return { ...state, saveAnalyticsKey };
};
